import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tonbsp',
    standalone: false
})
export class ToNbspPipe implements PipeTransform
{
    transform (value: string, addTrailingSpace: boolean): unknown
    {
        let temp = value.replace(/\s/ig, '&nbsp;');

        if (addTrailingSpace)
        {
            temp += '&nbsp;';
        }

        return temp;
    }
}
